import { useEffect } from 'react';

/**
 * Hook to set the document title dynamically
 * @param {string} title - The page title (will be appended with "| ConnectEd")
 */
export function usePageTitle(title) {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title ? `${title} | ConnectEd` : 'ConnectEd - Childcare Management';
    
    return () => {
      document.title = previousTitle;
    };
  }, [title]);
}

export default usePageTitle;
